import { Box } from '@mui/material';
import { Row } from '@tanstack/react-table';
import React from 'react';

export interface EmptyTreeNodeProps<T extends object> {
    row: Row<T>;
}

const EmptyTreeNode = <T extends object>({ row }: EmptyTreeNodeProps<T>) => {
    const parentRow = row.getParentRow();
    let isLastLeaf = false;

    if (parentRow) {
        const subRowId = row.id.split('.')[1];
        const subRow = subRowId ? Number(subRowId) : null;

        isLastLeaf = subRow === parentRow.subRows.length - 1;
    }

    return (
        <Box className="tree-branch">
            <Box className="top"></Box>
            <Box className={`bottom ${isLastLeaf ? 'last-leaf' : ''}`}></Box>
        </Box>
    );
};

/* <Box className="tree-branch">
            <Box className="dashes">
                <Box className="top"></Box>
                <Box className={`bottom ${isLastLeaf ? 'last-leaf' : ''}`}></Box>
            </Box>
            <Box className="arrow">
                <ArrowRightIcon
                    // sx={{
                    //     // ml: 0.5,
                    //     fontSize: '1.2rem',
                    // }}
                />
            </Box>
        </Box> */

export default EmptyTreeNode;
